<div class="content">    
  <router-outlet></router-outlet>
  <app-spinner></app-spinner>
  <app-toast-component></app-toast-component>
</div>
